import { Card, CardContent } from "@/components/ui/card";
import { QuoteIcon } from "lucide-react";
import Peter from "@/assets/img/NigerianMan.png";

const testimonials = [
  {
    quote:
      "CecureStream Events transformed how we manage our corporate webinars. The registration system is flawless, and our attendees love the experience.",
    author: "Sarah Johnson",
    position: "Marketing Director",
    company: "TechGrowth Inc.",
    avatar: "https://randomuser.me/api/portraits/women/41.jpg",
  },
  {
    quote:
      "We increased our event attendance by 40% after switching to CecureStream Events. The analytics tools helped us understand our audience better.",
    author: "Michael Peterson",
    position: "Events Manager",
    company: "GlobalConnect",
    avatar: Peter,
    // avatar: "https://randomuser.me/api/portraits/men/32.jpg"
  },
  {
    quote:
      "The platform's reliability is what impressed us the most. We hosted a global conference with 5,000+ attendees without a single technical issue.",
    author: "Emma Rodriguez",
    position: "VP of Operations",
    company: "FutureConference",
    avatar: "https://randomuser.me/api/portraits/women/63.jpg",
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-cecure-900 mb-4">
            Trusted by Event Organizers Worldwide
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See what our customers have to say about their experience using
            CecureStream Events
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="border-0 shadow-md hover:shadow-lg transition-shadow"
            >
              <CardContent className="p-6">
                <QuoteIcon className="h-8 w-8 text-cecure-500 mb-4" />
                <p className="text-gray-700 mb-6 italic">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.author}
                    className="h-12 w-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-semibold text-cecure-900">
                      {testimonial.author}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {testimonial.position}, {testimonial.company}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-16 py-8 px-6 bg-cecure-800 rounded-lg shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-y-6 gap-x-8 text-center">
            <div className="px-4">
              <div className="text-3xl font-bold text-white mb-2">4,500+</div>
              <p className="text-blue-200">Events Created</p>
            </div>
            <div className="px-4">
              <div className="text-3xl font-bold text-white mb-2">2.8M+</div>
              <p className="text-blue-200">Registered Attendees</p>
            </div>
            <div className="px-4">
              <div className="text-3xl font-bold text-white mb-2">98%</div>
              <p className="text-blue-200">Customer Satisfaction</p>
            </div>
            <div className="px-4">
              <div className="text-3xl font-bold text-white mb-2">150+</div>
              <p className="text-blue-200">Countries Reached</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
